/**
 * Azure AD B2C Configuration
 *
 * This file contains the MSAL configuration for Azure AD B2C authentication.
 * Update the environment variables in .env files with your B2C tenant details.
 */

const loggerOptions = {
  loggerCallback: (level, message, containsPii) => {
    if (containsPii) {
      return
    }
    switch (level) {
      case 0: // LogLevel.Error
        console.error(message)
        break
      case 1: // LogLevel.Warning
        console.warn(message)
        break
      case 2: // LogLevel.Info
        console.info(message)
        break
      case 3: // LogLevel.Verbose
        console.debug(message)
        break
    }
  }
}

/**
 * Build the MSAL configuration from the auth config returned by /AuthConfig/v2.
 *
 * @param {Object} authConfig - { clientId, apiScope, authorityDomain, tenantName, policyName }
 * @returns {Object} MSAL configuration
 */
export function buildMsalConfig(authConfig) {
  const authority = `https://${authConfig.authorityDomain}/${authConfig.tenantName}.onmicrosoft.com/${authConfig.policyName}`

  return {
    auth: {
      clientId: authConfig.clientId,
      authority,
      knownAuthorities: [authConfig.authorityDomain],
      redirectUri: process.env.VUE_APP_B2C_REDIRECT_URI || window.location.origin,
      postLogoutRedirectUri: process.env.VUE_APP_B2C_POST_LOGOUT_REDIRECT_URI || window.location.origin
    },
    cache: {
      cacheLocation: 'localStorage', // This configures where your cache will be stored
      storeAuthStateInCookie: false // Set to true for IE 11 or Edge
    },
    system: {
      loggerOptions
    }
  }
}

export function buildAuthScopes(authConfig) {
  return [
    authConfig.apiScope || 'openid',
    'profile',
    'email',
    'offline_access'
  ]
}
